/**
 * Histogram V2 Analysis API
 *
 * Generates histogram data by binning accounts based on a specified attribute (e.g., risk score)
 * and aggregating a y-axis metric (e.g., AUM, account count) for each bin.
 *
 * Key differences from V1:
 * - `yAxisColumn`: Column to aggregate (e.g., `organizationalBaseMarketValue`, `aggIDValue`)
 * - `yAxisAggregationMethod`: How to aggregate (`SUM`, `COUNT`, etc.)
 * - `aggregationOutput`: Result format (`ABSOLUTE` values or `PERCENTAGE` of total)
 *
 * @see https://webster.bfm.com/Wiki/display/AFWM/Histogram+v2
 * @see https://spc.blackrock.com/aladdinwealth_beta/swagger-ui/index.html#/analysis-controller/histogramV2
 */
import type { AxiosResponse, CancelToken } from 'axios';
import { isAGraphEnabled } from '../AGraphUtils';
import { awApiWithPkg } from '../Base';
import { HistogramAnalysisV2Request, HistogramAnalysisV2Response } from './types';

export function postHistogramAnalysisV2(
  request: HistogramAnalysisV2Request,
  cancelToken?: CancelToken
): Promise<AxiosResponse<HistogramAnalysisV2Response>> {
  const path = isAGraphEnabled() ? '/v2/analysis/histogram' : '/analysis/v2/histogram';
  return awApiWithPkg.post<HistogramAnalysisV2Response>(path, request, { cancelToken, params: { pkg: request.pkg } });
}
